<template>
  <div class="wrap">
    <div class="header">
      <h3 class="title">我的作业</h3>
      <div class="search-box">
        <el-input placeholder="搜索课程名称" v-model="keyword">
          <i slot="suffix" class="el-icon-search" @click="handleSearch"></i>
        </el-input>
      </div>
    </div>
    <div class="course-content">
      <table class="table">
        <tr class="table-header">
          <th class="left-headr">课程信息</th>
          <th>班期名称</th>
          <th class="left-headr">章节名称</th>
          <th>待完成作业数</th>
          <th>操作</th>
        </tr>
        <tr v-for="item of homeworkList" :key="item.id">
          <td>{{item.course_name}}</td>
          <td>{{item.class_name}}</td>
          <td>{{item.chapter_id?item.chapter_name:item.section_name}}</td>
          <td :style="item.count>=1?'color:#FF571F;':''">{{item.count}}</td>
          <td style="color:#1872ED; font-size:12px;cursor:pointer" @click="toHomeworkDetailPage(item)">     
            <span>作业明细</span>
            <span v-show="item.read_status==1" class="red-dot"></span>
          </td>
        </tr>
      </table>
    </div>
    <div class="pagination">
      <el-pagination background  @current-change="handleCurrentChange"  layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword:'',
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      homeworkList:[],
      total:0
    }
  },
  created() {
    this.getHomeworkList()
  },

  methods: {
    getCourseHomeworkRead(){
      this.$tenghuiApi.post('/onlineapi/user/index/getCourseRead').then(res=>{
        console.log('[<-- res作业未读数 -->]',res);
        if (res.data.code==200) {
          this.unreadCount=res.data.data
        }    
      })  
    },
    async getHomeworkList(){
      const data = {
        page:this.page,
        page_nums:10
      }
      if(this.keyword){
        data.keyword = this.keyword
      }
      const res = await this.$tenghuiApi.post('/onlineapi/user/index/taskList',data)
      if(res.data.code == 200 ){
        console.log('res作业列表',res);
        this.homeworkList = res.data.data.list
        this.total = res.data.data.count
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getHomeworkList()
    },
    handleSearch(){
      this.page = 1 
      this.getHomeworkList()
    },
    async toDetail(item){
        const data={
          course_id:item.course_id,
          chapter_id:item.chapter_id,
          section_id:item.section_id
        }
        const res=await this.$tenghuiApi.post('/onlineapi/user/index/courseRead',data)
        console.log('[<-- res点击红点 -->]',res);
    },
   async toHomeworkDetailPage(item){
      await this.toDetail(item)
      await this.getCourseHomeworkRead()
      this.$emit('changePage',{page:'HomeworkDetail',query:item})
    }
  },
}
</script>

<style lang="scss" scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
th{
  font-weight: normal;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  height: 880px;
  .header{
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    display: flex;
    align-items: center;
    .search-box{
      width: 180px;
      margin-left: auto;
      ::v-deep .el-input__inner{
        border: none;
        background: #F7F7F7;
        border-radius:18px
      }
      ::v-deep .el-input__suffix{
        color: #1872ed;
      }
      ::v-deep .el-input__suffix{
        top: 9px;
        right: 10px;
        cursor: pointer;
      }
    }
  }
}
.title {
  font-size: 20px;
  color: #202020;
}
.red-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 50%; 
  margin-left: 5px;
}
.course-content {
  margin-top: 20px;
  padding: 0px 20px 0 30px;
  box-sizing: border-box;
  font-size: 14px;
  max-height: 700px;
  overflow-y: auto;
  .table{
    width: 100%;
    border: 1px solid #e8eaec;
    border-collapse:collapse;
  }
  tr{
      width: 100%;
      display: grid;
      grid-template-columns: 2fr 1fr 2fr 1fr 1fr;
      justify-content: center;
      align-items: center;
      min-height: 50px;
      th{
        border-right: 1px solid #e8eaec;
        height: 100%;
        line-height: 50px;
        border-bottom: 1px solid #e8eaec;

      }
      th:last-child{
        border-right: none;
      }
      td{
        border-right: 1px solid #e8eaec;
        border-bottom: 1px solid #e8eaec;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      td:last-child{
        border-right: none;
      }
  }
  tr:first-child th{
    border-bottom: none;
  }
  tr:last-child td{
    border-bottom: none;
  }
  .table-header{
      background: #F5F6F7;
      color: #808695;
      .left-headr{
        // text-align: left;
        // padding-left: 20px;
      }
  }
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #1872ed;
}


</style>
